import { Data, Model } from '@singularsystems/neo-core';
import { AxiosPromise } from 'axios';
import { injectable } from 'inversify';
import { AppService, Types } from '../DomainTypes';
import Investment from '../Models/Investment/Investment';
import DividendAccrualLookup from '../Models/Dividends/Lookups/DividendAccrualLookup';
import EditDividendCommand from '../Models/Dividends/Commands/EditDividendCommand';

export interface IInvestmentApiClient {

    /**
     * Gets an investment record for editing in the ui.
     * @param investmentId Investment id to load.
     */
    getInvestment(investmentId: number): AxiosPromise<Model.PlainTrackedObject<Investment>>;

    /**
     * Gets a list of accrual lookups for an investment.
     */
    getDividendAccruals(investmentId: number, regenerate?: boolean): AxiosPromise<Array<Model.PlainObject<DividendAccrualLookup>>>;

    /** 
     * Deletes a dividend and its related records.
     */
    deleteDividend(dividendId: number): AxiosPromise;

    /** 
     * Edits or creates a dividend.
     */
    editDividend(command: Model.PartialPlainObject<EditDividendCommand>): AxiosPromise;

    // Client only properties / methods
}

@injectable()
export default class InvestmentApiClient extends Data.ApiClientBase implements IInvestmentApiClient {

    constructor (config = AppService.get(Types.App.Config)) {
        super(`${config.apiPath}/investments`);
    }

    public getInvestment(investmentId: number): AxiosPromise<Model.PlainTrackedObject<Investment>> {
        return this.axios.get(`${this.apiPath}/${investmentId}`);
    }

    public getDividendAccruals(investmentId: number, regenerate: boolean = false): AxiosPromise<Array<Model.PlainObject<DividendAccrualLookup>>> {
        return this.axios.get(`${this.apiPath}/accruals/${investmentId}?regenerate=${regenerate}`);
    }

    public deleteDividend(dividendId: number): AxiosPromise {
        return this.axios.delete(`${this.apiPath}/dividend/${dividendId}`);
    }

    public editDividend(command: Model.PartialPlainObject<EditDividendCommand>): AxiosPromise {
        return this.axios.post(`${this.apiPath}/dividend`, command);
    }

    // Client only properties / methods
}